import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useLayerCategoryLayerRemoveMutation } from "@/v2-backoffice-client/layer/category/layer/remove/layer.category.layer.remove.mutation"

export type LayerCategoryLayerRemoveButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  onCompleted?(): void
  layerFeatureCode: string
  categoryFeatureCode: string
  confirmDescription?: string
}

function LayerCategoryLayerRemoveButton(
  props: LayerCategoryLayerRemoveButtonProps,
) {
  const {
    layerFeatureCode,
    categoryFeatureCode,
    confirmDescription,
    onCompleted,
    children,
    ...rest
  } = props

  const [removeFromCategory, { loading, error }] =
    useLayerCategoryLayerRemoveMutation({
      onCompleted,
    })

  errorToast(error, {
    title: "Failed to remove layer from category",
  })

  return (
    <ConfirmButton
      variant="ghost"
      size="xs"
      iconSrc="cross-small"
      content="Remove from category"
      confirmContent={
        confirmDescription ??
        "Are you sure you want to remove this layer from the category?"
      }
      isSquare={!children}
      isLoading={loading}
      onConfirm={() => {
        removeFromCategory({
          variables: { layerFeatureCode, categoryFeatureCode },
        })
      }}
      {...rest}
    >
      {children}
    </ConfirmButton>
  )
}

export default LayerCategoryLayerRemoveButton
